export class LocalStorageCacheStore {
    constructor(logger, keyPrefix = 'sp:') {
        this.logger = logger;
        this.keyPrefix = keyPrefix;
    }
    storageKey(key) {
        return this.keyPrefix + key;
    }
    async get(key) {
        const storageKey = this.storageKey(key);
        let raw;
        try {
            raw = localStorage.getItem(storageKey);
        }
        catch (error) {
            this.logger?.error('[LocalStorageCacheStore] Failed to read from localStorage', { error: error, key });
            return null;
        }
        if (raw === null)
            return null;
        let entry;
        try {
            entry = JSON.parse(raw);
        }
        catch (error) {
            this.logger?.error('[LocalStorageCacheStore] Failed to parse cache entry', { error: error, key });
            return null;
        }
        if (entry.expiresAt !== null && Date.now() > entry.expiresAt) {
            try {
                localStorage.removeItem(storageKey);
            }
            catch {
                // best-effort
            }
            return null;
        }
        return entry.value;
    }
    async set(key, value, ttl) {
        const expiresAt = ttl ? Date.now() + ttl * 1000 : null;
        const entry = { value, expiresAt };
        const raw = JSON.stringify(entry);
        const storageKey = this.storageKey(key);
        try {
            localStorage.setItem(storageKey, raw);
        }
        catch {
            // Quota hit: reclaim expired entries under our prefix and retry once.
            this.sweepExpired();
            try {
                localStorage.setItem(storageKey, raw);
            }
            catch (retryError) {
                this.logger?.error('[LocalStorageCacheStore] Failed to write to localStorage (quota?)', { error: retryError, key });
            }
        }
    }
    sweepExpired() {
        try {
            const now = Date.now();
            const stale = [];
            for (let i = 0; i < localStorage.length; i++) {
                const k = localStorage.key(i);
                if (!k || !k.startsWith(this.keyPrefix))
                    continue;
                try {
                    const entry = JSON.parse(localStorage.getItem(k) ?? '');
                    if (entry.expiresAt !== null && now > entry.expiresAt)
                        stale.push(k);
                }
                catch {
                    stale.push(k); // corrupt entry — reclaim
                }
            }
            for (const k of stale)
                localStorage.removeItem(k);
        }
        catch {
            // best effort
        }
    }
    async delete(key) {
        try {
            localStorage.removeItem(this.storageKey(key));
        }
        catch (error) {
            this.logger?.error('[LocalStorageCacheStore] Failed to delete from localStorage', { error: error, key });
        }
    }
}
//# sourceMappingURL=LocalStorageCacheStore.js.map